/* eslint-disable arrow-body-style */
import React from 'react';

import { Skeleton } from '@abyss/web/ui/Skeleton';

export const ResultsSearchingTable = () => {
  return (
    <div
      className="resultsSearching"
      data-testid="eventSearchResultsSearching"
      data-cy="eventSearchResultsSearching"
    >
      <Skeleton
        height={500}
        variant="rounded"
        css={{
          'abyss-skeleton-root': {
            background: '$gray2',
          },
        }}
        loadingText="Event Search, Searching data, Waiting for data"
      />
    </div>
  );
};
